import React from 'react';
import PropTypes from 'prop-types';
import CheckCircle from 'assets/img/check-circle.svg';

function Account(props) {
    const {
        selectedAccountId,
        onSelect,
        data,
    } = props;
    const accountId = data.get('accountId');
    const isActive = !!data.get('isActive');
    const isSelected = selectedAccountId && selectedAccountId === accountId;

    return (
        <div className={`account-list-item${isSelected ? ' selected' : ''}`}>
            <button key={accountId} onClick={() => onSelect(accountId)}>

                {/* Indicate account status */}
                {isActive ? null : <span className={'inactive-badge'}>Inactive Account</span>}

                <div className={'account-detail'}>
                    <div className={'account-title'}>{data.get('name')}</div>
                    <div className={'account-id'}>#{accountId}</div>
                    <div className={'account-address'}>{data.get('address')}</div>
                </div>
                {isSelected ? <img className='selected-account-icon' src={CheckCircle} alt='selected account' /> : null}
            </button>
        </div>
    );
}

Account.propTypes = {
    data: PropTypes.object,
    onSelect: PropTypes.func,
    selectedAccountId: PropTypes.string,
};

export default Account;
